module.exports = __webpack_public_path__ + "static/media/es.pictogram.f52f377e.svg";